"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var sitecore_jss_forms_1 = require("@sitecore-jss/sitecore-jss-forms");

var default_field_factory_1 = __importDefault(require("../default-field-factory"));

var default_error_1 = require("./default-error");

var Form =
/** @class */
function (_super) {
  __extends(Form, _super);

  function Form(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      errors: [],
      // in a multistep form the server can reset the form schema
      // to display further steps; this state property overrides
      // the form passed in from props if present
      nextForm: null,
      submitButton: null
    }; // workaround index type limitations in TS

    _this.createFieldComponent = _this.createFieldComponent.bind(_this);
    _this.getCurrentFieldState = _this.getCurrentFieldState.bind(_this);
    _this.collectCurrentFieldValues = _this.collectCurrentFieldValues.bind(_this);
    _this._tracker = new sitecore_jss_forms_1.FormTracker({
      endpoint: _this.props.sitecoreApiHost + "/api/jss/fieldtracking/register?sc_apikey=" + _this.props.sitecoreApiKey,
      fetcher: _this.props.trackerFetcher
    });
    return _this;
  }

  Form.prototype.render = function () {
    var form = this.state.nextForm || this.props.form;

    if (!form) {
      return react_1.default.createElement("div", null, "No form data was provided. Need to set a datasource?");
    }

    if (!form.metadata) {
      return react_1.default.createElement("div", null, "Form data invalid. Forget to set the rendering contents resolver?");
    }

    var action = this.props.sitecoreApiHost + "/api/jss/formbuilder?fxb.FormItemId=" + form.metadata.itemId + "&fxb.HtmlPrefix=" + form.htmlPrefix + "&sc_apikey=" + this.props.sitecoreApiKey + "&sc_itemid=" + form.contextItemId;

    this._tracker.setFormData(form.formItemId.value, form.formSessionId.value, form.metadata.isTrackingEnabled);

    var fieldComponents = form.fields.map(this.createFieldComponent);
    var ErrorComponent = this.props.errorComponent || default_error_1.DefaultError;
    var fieldErrors = this.collectCurrentFieldValues().filter(function (field) {
      return !field.state.isValid;
    });
    return react_1.default.createElement("form", {
      action: action,
      method: "POST",
      onSubmit: this.onSubmit.bind(this)
    }, react_1.default.createElement(ErrorComponent, {
      form: form,
      formErrors: this.state.errors,
      fieldErrors: fieldErrors
    }), fieldComponents);
  };
  /**
   * Creates a field component to render a field based on the form schema data
   * @param {FormField} field
   * @returns {React.ReactNode} field component
   */


  Form.prototype.createFieldComponent = function (field) {
    var props = __assign({
      field: field,
      key: field.model.itemId,
      onChange: this.onFieldChange.bind(this),
      onButtonClick: this.onButtonClick.bind(this),
      fieldFactory: this.createFieldComponent,
      fieldValidationErrorsComponent: this.props.fieldValidationErrorsComponent,
      labelComponent: this.props.labelComponent,
      tracker: this._tracker
    }, this.getCurrentFieldState(field));

    var component = (this.props.fieldFactory || default_field_factory_1.default).get(field, props);

    if (this.props.fieldWrapperComponent) {
      var Wrapper = this.props.fieldWrapperComponent;
      return react_1.default.createElement(Wrapper, __assign({}, props), component);
    }

    return component;
  };
  /**
   * Acquires the current form field state for a single field.
   * This state can come from two possible sources:
   * - The form schema/current data (default values, previously saved steps in multistep)
   * - This component's state (the mutated state of the field after user changes)
   * The field state includes both current value as well as current validity.
   * @param {FormField} field
   * @returns {Object | null} field state
   */


  Form.prototype.getCurrentFieldState = function (field) {
    // non-valued fields, i.e. text, section, do not have a value or validity state
    if (!sitecore_jss_forms_1.instanceOfValueFormField(field)) {
      return null;
    }

    var fieldName = field.valueField.name || null;

    if (!fieldName) {
      return null;
    }

    var fieldState = this.state[fieldName]; // field has a value in react state i.e. due to user change

    if (fieldState) {
      var result = {
        isValid: fieldState.isValid,
        errors: fieldState.errors || []
      };

      if (typeof fieldState.value !== 'undefined') {
        // field state from changed field value (in this.state)
        result.value = fieldState.value;
      } else {
        result.value = sitecore_jss_forms_1.getFieldValueFromModel(field);
      }

      return result;
    } // default state from form API model


    return {
      isValid: true,
      errors: [],
      value: sitecore_jss_forms_1.getFieldValueFromModel(field)
    };
  };
  /**
   * Handler triggered by child components that informs us which button triggered a submit.
   * This is important for multistep forms to disambiguate between back and next/submit buttons.
   * @param {string} buttonName
   */


  Form.prototype.onButtonClick = function (buttonName) {
    this.setState({
      submitButton: buttonName
    });
  };
  /**
   * Handler triggered by child components that updates a given field's current value
   * (which we then push back down to the child via prop)
   * @param {string} key Field's name attribute
   * @param {string | string[] | File[]} value New field value
   * @param {boolean} isValid Whether the field is valid or not
   * @param {string[]} errors Validation error message(s) if field is invalid
   */


  Form.prototype.onFieldChange = function (key, value, isValid, errors) {
    var _a;

    this.setState((_a = {}, _a[key] = {
      value: value,
      isValid: isValid,
      errors: errors
    }, _a));
  };
  /**
   * Handler triggered when the form is submitted. May transition its state between
   * steps in a multistep form or handle a final submit.
   * @param {FormEvent} e
   */


  Form.prototype.onSubmit = function (e) {
    var _this = this;

    e.preventDefault();
    var form = this.state.nextForm || this.props.form;
    var fieldValues = {};
    var currentFieldValues = this.collectCurrentFieldValues();
    currentFieldValues.forEach(function (field) {
      if (typeof field.state.value !== 'undefined') {
        fieldValues[field.fieldName] = field.state.value;
      }
    }); // NOTE: we're not pre-validating the submit on the client because
    // Sitecore won't be able to track validation errors in xConnect
    // serialize the form data that we got from the server
    // (hidden fields with constant values, unchanged default field values, etc)

    var formData = sitecore_jss_forms_1.serializeForm(form, {
      submitButtonName: this.state.submitButton
    }); // merge in user-updated field values

    formData.mergeOverwritingExisting(fieldValues);
    var submitUrl = e.target.action;

    if (!submitUrl) {
      throw new Error('Submit URL was not defined. Ensure the form has an action attribute.');
    }

    sitecore_jss_forms_1.submitForm(formData, submitUrl, {
      fetcher: this.props.formFetcher
    }).then(function (result) {
      if (result.success && result.redirectUrl) {
        // Process redirect-on-success action.
        if (_this.props.onRedirect) {
          _this.props.onRedirect(result.redirectUrl);
        } else {
          window.location.href = result.redirectUrl;
        }
      }

      if (result.validationErrors) {
        var stateUpdate_1 = {};
        Object.keys(result.validationErrors).forEach(function (fieldKey) {
          stateUpdate_1[fieldKey] = {
            value: (_this.state[fieldKey] || {}).value,
            isValid: false,
            errors: result.validationErrors[fieldKey]
          };
        });

        _this.setState(stateUpdate_1);
      }

      if (result.nextForm) {
        _this.setState({
          nextForm: result.nextForm
        });
      }

      if (result.success) {
        _this.resetFieldsState();
      }

      if (result.errors && result.errors.length > 0) {
        throw result.errors;
      }

      _this.setState({
        errors: []
      });
    }).catch(function (error) {
      if (Array.isArray(error)) {
        _this.setState({
          errors: error
        });
      } else if (typeof error === 'string') {
        console.log('Form submit error', error);

        _this.setState({
          errors: [error]
        });
      } else {
        console.log('Form submit error', error);

        _this.setState({
          errors: [error.message]
        });
      }
    });
  };

  Form.prototype.collectCurrentFieldValues = function () {
    var _this = this;

    return Object.keys(this.state).filter(function (fieldName) {
      return _this.state[fieldName] && typeof _this.state[fieldName].isValid !== 'undefined';
    }).map(function (fieldName) {
      return {
        fieldName: fieldName,
        state: _this.state[fieldName]
      };
    });
  };
  /**
   * Removes the current fields' mutated state from this.state,
   * which prevents validation issues and mutable field state from following us
   * across steps in a multistep form.
   */


  Form.prototype.resetFieldsState = function () {
    var keys = Object.keys(this.state).filter(function (key) {
      return key !== 'nextForm' && key !== 'errors' && key !== 'submitButton';
    });
    var stateReset = keys.reduce(function (acc, v) {
      var _a;

      return __assign(__assign({}, acc), (_a = {}, _a[v] = undefined, _a));
    }, {});
    this.setState(__assign(__assign({}, stateReset), {
      errors: []
    }));
  };

  return Form;
}(react_1.Component);

exports.Form = Form;